import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useBusinessRedirect = (employees: boolean) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Login › iMetanic";
    const employee = sessionStorage.getItem("employee");
    const nonemployee = sessionStorage.getItem("Noemployee");

    if (!sessionStorage.getItem("jsonwebtoken")) {
      navigate("/");
    } else {
      if (employee || employees === true) {
        navigate("/v1/employee/home");
      } else if (nonemployee || employees === false) {
        navigate("/v1/home");
      }
    }
  }, [employees, navigate]);

  useEffect(() => {
    const business_type = sessionStorage.getItem("business_type");

    if (!sessionStorage.getItem("jsonwebtoken")) {
      navigate("/");
    } else {
      if (business_type === "Laundry") {
        navigate("/v1/home");
      } else if (business_type === "Restaurant") {
        navigate("/v1/Reshome");
      } else if (business_type?.trim() === "Carwash" || business_type === "Car wash") {
        navigate("/v1/new-order");
      } else if (business_type?.trim() === "Grocery") {
        navigate("/grocery/home");
      } else if(business_type?.trim() === "Saloon") {
         navigate("/v1/saloon-Home");
      }
    }
  }, [navigate]);
};
